import SimpleDictionaryTableConfig from '../../../components/common/SimpleDictionaryTableConfig';

const fields = {
  config: { columns: 2 },
  fields: [
    {
      name: 'id',
      column: 1,
      type: 'unvisible',
    },
    {
      name: 'name',
      label: 'Nazwa grupy',
      column: 1,
      type: 'text',
      mandatory: true,
    },
    {
      name: 'amenities',
      label: 'Udogodnienia',
      type: 'table',
      tableConfig: {
        api: 'amenity',
        columns: SimpleDictionaryTableConfig,
        checked: true,
      },
    },
  ],
};

export default fields;
